import { Spinner } from "@/components/ui/spinner";

export function AuthLoadingFallback() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="flex flex-col items-center gap-lg">
        <Spinner className="h-8 w-8 text-muted-foreground" />
        <span className="text-body-md text-muted-foreground">Chargement...</span>
      </div>
    </div>
  );
}
